<template>
    <div class="campaign-box campaign-box--no-top-border campaign-box--top-padding" data-dusk="add-funds">
        <div class="col-md-12 text-center" v-if="loading">
            <i class="fa fa-spinner fa-spin inner-loading"></i>
        </div>

        <form @submit.prevent="showAuthorizationModal" v-else>
            <div class="row">
                <div class="col-sm-12">
                    <validation-errors :errors="lineErrors"></validation-errors>
                </div>

                <div class="col-sm-4">
                    <h3>Credit Line {{ creditsAreVerticalized ? "" : "Allocation" }}</h3>
                    <hr>

                    <div>
                        <h3 style="margin-bottom:0px;">${{ (creditsAreVerticalized ? this.paymentPlan.amount : 0) | currency }}</h3>
                        <p class="text-muted">
                            Approved {{ creditsAreVerticalized ? fundsPool.name : "" }} Credit Line (Per Month)
                        </p>
                    </div>

                    <p class="m-b-lg text-muted" v-if="creditsAreVerticalized">
                        <span v-if="paymentPlan.locked && isPaymentPlanAutoRenew && paymentPlan.agreedToTerms" class="text-danger">If you have any questions about your Auto Renewal please contact your Account Manager or email us at <a href="mailto:support@bankrate.com">support@bankrate.com</a>.</span>
                        <span v-else>By accepting this credit line, you are electing to spend up to that amount for a specified time period which is either from today until the end of this month or for the next month.</span>
                    </p>
                    <p class="m-b-lg text-muted" v-else>
                        By allocating part or all of your credit line, you are electing up to that amount for a specified time period which is either from today until the end of this month or for the next month. The total credit allocations for all product categories cannot exceed the approved credit line amount.
                    </p>

                    <div v-if="showAvailableCredit && !creditsAreVerticalized">
                        <h3 style="margin-bottom:0px;">${{ availableCredit | currency }}</h3>
                        <p class="text-muted">
                            Available Credit
                        </p>
                    </div>
                </div>

                <div class="col-sm-8">
                    <div class="form-group" v-validation-field:fundsPoolId="lineErrors">
                        <label class="control-label">Product Category</label>

                        <select class="form-control" data-dusk="fundsPoolId" v-model="fundsPoolId">
                            <option :value="fundsPool.id" v-for="fundsPool in fundsPoolsForCredits">{{ fundsPool.name }}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <div class="col-md2"><label class="control-label">Start Date: </label></div>
                        <div class="col-md2"><label class="radio-inline"><input type="radio" id="one" value="today" v-model="startInterval">Today</label></div>
                        <div class="col-md2"><label class="radio-inline"><input type="radio" id="two" value="next-month" v-model="startInterval" :disabled="optsForAutoRenew || isPaymentPlanAutoRenew">{{ startOfNextMonth }}</label></div>
                        <p>
                            <div class="col-md2"><label class="control-label">End Date: </label></div>
                            <div class="col-md2">{{ endDate }}</div>
                        </p>
                    </div>

                    <div class="form-group" v-if="!creditsAreVerticalized" v-validation-field:amount="lineErrors">
                        <label class="control-label">Allocation Amount</label>
                        <input class="form-control" type="text" v-model="amount" v-money="moneyConfig" placeholder="$ 0">
                    </div>

                    <div class="form-group" v-if="showAutoRenew">
                        <label v-if="isPaymentPlanAutoRenew && (paymentPlan.locked || paymentPlan.agreedToTerms)" class="control-label --secondary">Auto Renewal: <span class="glyphicon glyphicon-ok-circle"></span> </label>
                        <label v-else class="control-label">Auto Renewal: <input type="checkbox" v-model="optsForAutoRenew"> </label>
                    </div>

                    <div class="form-group" v-if="!(showAutoRenew && (isPaymentPlanAutoRenew || optsForAutoRenew))">
                        <label class="control-label">PO Number (Optional)</label>
                        <input class="form-control" type="text" v-model="poNumber">
                    </div>
                </div>
            </div>

            <hr>

            <div class="pull-right">
                <template v-if="showAutoRenew && isPaymentPlanAutoRenew && this.paymentPlan.agreedToTerms && !this.paymentPlan.locked">
                    <button class="btn btn-danger --edit" @click="cancelAutoRenew">Cancel Auto Renewal</button>
                </template>
                <template v-else-if="showAutoRenew && isPaymentPlanAutoRenew && this.paymentPlan.agreedToTerms && this.paymentPlan.locked">

                </template>
                <template v-else>
                    <button class="btn btn-success --edit" v-if="!continueValidated" @click="checkContinueLogic">Continue</button>
                </template>
            </div>


            <div class="step-2" v-if="continueValidated">
                <div class="document-signatures col-md-8 col-md-offset-2">
                    <accordion :one-at-atime="true" type="info">
                        <panel
                                :type="isAllTermsAccepted ? 'success' : 'primary'"
                                :is-open="!isAllTermsAccepted">
                            <strong slot="header">
                                Terms and Conditions

                                <span v-if="isAllTermsAccepted" class='glyphicon glyphicon-ok pull-right'></span>
                            </strong>

                            <div class="terms-text">
                                This advertising relationship is governed by the Master Advertising Services Agreement between the parties (the “Agreement”). For the avoidance of doubt, the parties expressly agree that this Agreement replaces and supersedes all other terms and conditions with respect to the parties’ non-display advertising relationship, including, without limitation, all click, lead, and call campaigns.
                            </div>
                            <div class="agree_box document-signature__toggle overflow-hidden">
                                <div class="float-left">
                                    <small>As a representative of this organization I am authorized to accept these terms and conditions</small>
                                </div>
                                <div class="float-right">
                                    <small>Accept </small><input type="checkbox" v-model="acceptedTerms"/>
                                </div>
                            </div>
                            <div v-if="showAutoRenew && (optsForAutoRenew || isPaymentPlanAutoRenew)" class="agree_box document-signature__toggle overflow-hidden">
                                <div class="float-left">
                                    <small>I authorize the automatic renewal of this credit line on the first of every month.</small>
                                </div>
                                <div class="float-right">
                                    <small>Accept </small><input type="checkbox" v-model="acceptedAutoRenew"/>
                                </div>
                            </div>
                        </panel>
                    </accordion>
                </div>

                <hr class="col-md-12">

                <div class="pull-right" v-if="isAllTermsAccepted">
                    <button class="btn btn-success --edit" @click="save">Save</button>
                </div>
            </div>

        </form>

        <div style="clear:both">
            <h3>Activity Log</h3>
            <label v-if="loadingActivityLog"> <i class="fa fa-spinner fa-spin" title="loading"></i> </label>
            <table v-else class="table table-striped table-condensed table-responsive">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>IO Id / PO Number</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Amount</th>
                    <th>Amount Spent</th>
                    <th>Product Category</th>
                    <th>Who</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="activity in activityLog">
                    <td>{{ activity.updated_at | date }}</td>
                    <td>{{ activity.properties.ioId }}<br>{{ activity.properties.poNumber }}</td>
                    <td><span v-if="activity.properties.startDateStr">{{ activity.properties.startDateStr | date }}</span></td>
                    <td><span v-if="activity.properties.endDateStr">{{ activity.properties.endDateStr | date }}</span></td>
                    <td><span v-if="activity.properties.amount">${{ activity.properties.amount | currency }}</span></td>
                    <td><span v-if="activity.properties.amount">${{ activity.amountSpent | currency }}</span></td>
                    <td>{{ activity.accountName | capitalize }}</td>
                    <td>{{ activity.causerName }}</td>
                </tr>
                <tr v-if="!activityLog.length">
                    <td class="text-center" colspan="8">
                        <span class="text-muted">No activity recorded</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script type="text/babel">
    import ValidationErrors from './../utils/validation-errors.vue';
    import ValidationField from './../../directives/validation-field';
    import VueStrap from 'vue-strap';
    import { VMoney } from 'v-money';
    import ToggleButton from 'vue-js-toggle-button';
    import Swal from "sweetalert2";
    Vue.use(ToggleButton);

    export default {
        directives: { 'validation-field': ValidationField, VMoney },

        components: {
            'validation-errors': ValidationErrors,
            accordion: VueStrap.accordion,
            panel: VueStrap.panel,
        },

        props: {
            loading: Boolean,
            creditLine: Object,
            fundsPools: Array,
            paymentPlans: Array,
            fundsPoolsForCredits: Array,
        },

        data() {
            return {
                lineErrors: {},
                moneyConfig: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '$ ',
                    precision: 0,
                    // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
                    masked: false /* doesn't work with directive */
                },
                fundsPool: {},
                fundsPoolId: 0,
                fundsPoolsCreditUsed: [],
                startInterval: 'today',
                availableCredit: null,
                poNumber: '',
                continueValidated: false,
                acceptedTerms: false,
                acceptedAutoRenew: false,
                optsForAutoRenew: false,
                showAvailableCredit: false,
                saving: false,
                amount: null,
                activityLog: [],
                loadingActivityLog: true,
                creditsAreVerticalized: false,
                paymentPlan: {}
            }
        },

        created() {
            this.fundsPool = this.fundsPoolsForCredits[0];
            this.fundsPoolId = this.fundsPool.id;
            this.setCreditsAreVerticalized();
            this.getAvailableCredit();
            this.getActivityLog();
        },

        watch: {
            startInterval() {
                this.lineErrors = {};
                this.getAvailableCredit();
            },

            optsForAutoRenew(newValue, oldValue) {
                // auto-renew takes care of next month, but not the current; need to make sure any unallocated vert credit
                // is allocated to the current month now
                if (oldValue === false && newValue === true) {
                    this.startInterval = 'today';
                }
            },

            fundsPoolId() {
                this.lineErrors = {};
                this.fundsPool = this.fundsPoolsForCredits.find(fundsPool => { return fundsPool.id === this.fundsPoolId });
                this.optsForAutoRenew = false; // reset when switching between product categories
                this.acceptedTerms = false;
                this.acceptedAutoRenew = false;
                this.setCreditsAreVerticalized();
            }
        },

        computed: {
            startOfNextMonth() {
                let today = new Date();
                let startOfNext = new Date(today.getFullYear(), today.getMonth()+1, 1);

                return startOfNext.toLocaleDateString("en-US", {year: 'numeric', month: 'long', day: 'numeric' });
            },

            showAutoRenew() {
                return this.featureFlag('billing.show-auto-renew-credit-line') === true  && this.isInvoicedPaymentPlan
            },

            isPaymentPlanAutoRenew() {
                return this.paymentPlan.type === 'Auto-Renewing-Credit'
            },

            isInvoicedPaymentPlan() {
                return this.paymentPlan.type === 'Auto-Renewing-Credit' || this.paymentPlan.type === 'Direct-Bill'
            },

            isAllTermsAccepted() {
                return (this.isPaymentPlanAutoRenew || this.optsForAutoRenew) ? this.isAutoRenewTermsAccepted  : this.isManualRenewTermsAccepted;
            },

            isManualRenewTermsAccepted() {
                return this.acceptedTerms
            },

            isAutoRenewTermsAccepted() {
                return this.acceptedTerms && this.acceptedAutoRenew
            },

            endDate() {
                let whichMonthOffset = this.startInterval === 'today' ? 1 : 2;
                let today = new Date();
                let endOfMonth = new Date(today.getFullYear(), today.getMonth()+whichMonthOffset, 0);

                return endOfMonth.toLocaleDateString("en-US", {year: 'numeric', month: 'long', day: 'numeric' });
            }
        },

        methods: {
            showAuthorizationModal() {
                return;
            },

            checkContinueLogic() {
                if (this.creditsAreVerticalized) {
                    let fundsPoolCreditUsed = this.fundsPoolsCreditUsed.find(creditsTotal => { return creditsTotal.fundsPoolId === this.fundsPoolId });
                    let alreadyAllocatedCents = fundsPoolCreditUsed ? fundsPoolCreditUsed.totalAmountCents : 0;
                    let lineAmountCents = this.paymentPlan.amount * 100;
                    let remainingAmountCents = lineAmountCents - alreadyAllocatedCents;

                    if (remainingAmountCents > 0 || (this.showAutoRenew && (this.isPaymentPlanAutoRenew || this.optsForAutoRenew))) {
                        this.amount = remainingAmountCents / 100;
                        this.continueValidated = true;
                        this.lineErrors = {}; // clear out errors
                    } else {
                        this.lineErrors = { 'amount': 'The entire available credit line has already been allocated for the time period you selected.' };
                    }
                } else {
                    // amount requested must be greater than zero, and less than the amount available
                    let amount = this.stripNonNumericCharacters(this.amount);
                    if (amount > 0 && amount <= this.availableCredit) {
                        this.continueValidated = true;
                        this.lineErrors = {}; // clear out errors
                    } else {
                        this.lineErrors = { 'amount': 'The allocation amount must be less than the available credit.' };
                    }
                }
            },

            getAvailableCredit() {
                this.showAvailableCredit = false;

                this.$http.get(route('api.advertiser.credit-balance.show', {
                    "yearMonth": this.getStartIntervalYearMonth(this.startInterval),
                })).then(response => {
                    let creditUsed = response.data.totalCreditCents;
                    this.availableCredit = creditUsed / 100;
                    this.fundsPoolsCreditUsed = response.data.fundsPoolTotals;

                    this.showAvailableCredit = true;
                });
            },

            getFundsPoolsWithCreditLines() {
                return this.fundsPools.filter((i) => {
                    let relatedPaymentPlan = _(this.paymentPlans).find({ fundsPoolId: i.id });

                    return relatedPaymentPlan.type === 'Direct-Bill' || relatedPaymentPlan.type === 'Auto-Renewing-Credit'
                });
            },

            getStartIntervalYearMonth(startInterval) {
                let today = new Date();
                switch (startInterval) {
                    case 'today':
                        return today.getFullYear()+'-'+this.getTwoDigitMonth(today);
                    case 'next-month':
                        let nextMonth = new Date(today.getFullYear(), today.getMonth()+1, 1);

                        return nextMonth.getFullYear()+'-'+this.getTwoDigitMonth(nextMonth);
                }
            },

            getTwoDigitMonth(date) {
                let month = this.getHumanMonth(date);

                return month < 10 ? '0'+month : month;
            },

            getHumanMonth(date) {
                return date.getMonth() + 1; // getMonth is 0 indexed in javascript!!
            },

            stripNonNumericCharacters(amount) {
                return Number(amount.toString().replace(/[^0-9\.-]+/g,""));
            },

            save() {
                if (this.saving) {
                    return;
                }

                this.checkContinueLogic();
                if ('amount' in this.lineErrors) {
                    return false; // cannot save with errors
                }

                this.saving = true;

                // either admin configured auto-renew or opting for auto-renew and agreed to the terms
                if ((this.isPaymentPlanAutoRenew || this.optsForAutoRenew) && this.acceptedAutoRenew) {
                    // store they agreed at the payment plan level
                    this.$http.post(route('billing-setup.credit-line.activateAutoRenew'), {paymentPlanId: this.paymentPlan.paymentPlanId})
                      .then(() => {
                          // if we are only updating the payment plan (current month is fully allocated)
                          if (this.amount <= 0) {
                              sweetAlert.fire(
                                'Success',
                                'Credit Line Created!',
                                'success'
                              ).then(() => {
                                  this.$emit('refreshStep');
                              });
                          }
                      }).catch(({ status, data }) => {
                          if (status === 422) {
                              this.lineErrors = data.errors;
                          } else if (data.message && data.success === false) {
                              this.lineErrors = {message: [data.message]};
                          }

                        new Swal('Whoops!', 'Something went wrong configuring auto-renew. Please contact support.', 'error');
                          this.saving = false;
                      });
                }

                // if we saved the auto-renew choice/terms, but there is no credit remaining to create for the current month
                if (this.amount <= 0) {
                    return;
                }

                let payload = {
                    fundsPoolId: this.fundsPoolId,
                    accountName: this.fundsPool.name,
                    availableCreditCents: this.availableCredit * 100,
                    poNumber: this.poNumber,
                    startInterval: this.startInterval,
                    amountCents: this.stripNonNumericCharacters(this.amount) * 100,
                    creditsAreVerticalized: this.creditsAreVerticalized,
                };

                this.$http.post(route('billing-setup.credit-line.store'), payload)
                  .then(() => {
                      sweetAlert.fire(
                        'Success',
                        'Credit Line Created!',
                        'success'
                      ).then(() => {
                          this.$emit('refreshStep');
                      });
                  }).catch(({ status, data }) => {
                    if (status === 422) {
                        this.lineErrors = data.errors;
                    } else if (data.message && data.success === false) {
                        this.lineErrors = {message: [data.message]};
                    }
                    new Swal('Whoops!', 'Something went wrong. The credit line was most likely not created. Please contact support right away. ', 'error');
                    this.saving = false;
                });
            },

            getActivityLog() {
                const self = this;
                this.$http.get('/api/activity/logs/allocated-credit-line')
                  .then(({ data }) => {
                      this.activityLog = data.activityLog;
                      this.activityLog.forEach(function (activity) {
                          let dt = new Date(activity.properties.startDate) // utc date, we need to add (or subtract) timezone offset to set proper date
                          activity.properties.startDateStr = dt.setTime(dt.getTime() + (dt.getTimezoneOffset()*60*1000));
                          dt = new Date(activity.properties.endDate)
                          activity.properties.endDateStr = dt.setTime(dt.getTime() - (dt.getTimezoneOffset()*60*1000));
                          activity.properties.amount = activity.properties.amountDecimal ? activity.properties.amountDecimal : activity.properties.amountCents / 100;
                      });
                      this.loadingActivityLog = false;
                  });
            },

            cancelAutoRenew() {
                this.$http.post(route('billing-setup.credit-line.cancelAutoRenew'), {paymentPlanId: this.paymentPlan.paymentPlanId}).then(() => {
                    sweetAlert.fire(
                      'Success',
                      'Auto Renewal is Cancelled.',
                      'success'
                    ).then(() => {
                        this.$emit('refreshStep');
                    });
                }).catch(({ status, data }) => {
                    if (status === 422) {
                        this.lineErrors = data.errors;
                    } else if (data.message && data.success === false) {
                        this.lineErrors = {message: [data.message]};
                    } else {
                        new Swal('Whoops!', 'Something went wrong cancelling auto renewal. Please contact support.', 'error');
                    }
                });
            },

            setCreditsAreVerticalized() {
                this.creditsAreVerticalized = this.featureFlag('billing.show-verticalized-credit-line') === true;
                if (this.creditsAreVerticalized) {
                    this.paymentPlan = _(this.paymentPlans).find({ fundsPoolId: this.fundsPoolId });
                }
            }
        }
    }
</script>

<style scoped>
    .agree_box.overflow-hidden {
        overflow: hidden;
    }
    .agree_box .float-right {
        float: right;
    }
    .agree_box .float-left {
        float: left;
    }
    .terms-text {
        padding: 20px;
    }
    .text-danger {
        font-size: medium;
    }
</style>
